export { Wrapper };
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import React, { useState } from 'react';
import { StreamedHydration } from './StreamedHydration.js';
import { usePageContext } from 'vike-react/usePageContext';
function Wrapper({ children }) {
    const pageContext = usePageContext();
    const { queryClientConfig, FallbackErrorBoundary = PassThrough } = pageContext.config;
    const [queryClient] = useState(() => {
        const config = typeof queryClientConfig === 'function' ? queryClientConfig(pageContext) : queryClientConfig;
        return getQueryClient(config);
    });
    return (React.createElement(QueryClientProvider, { client: queryClient },
        React.createElement(FallbackErrorBoundary, null,
            React.createElement(StreamedHydration, { client: queryClient }, children))));
}
function PassThrough({ children }) {
    return React.createElement(React.Fragment, null, children);
}
let clientQueryClient;
function getQueryClient(config) {
    if (!isBrowser())
        return new QueryClient(config);
    // React may throw away a partially rendered tree if it suspends, and then start again from scratch.
    // If it's no suspense boundary between the creation of queryClient and useSuspenseQuery,
    // then the entire tree is thrown away, including the creation of queryClient, which may produce infinity refetchs
    // https://github.com/TanStack/query/issues/6116#issuecomment-1904051005
    // https://github.com/vikejs/vike-react/pull/157
    if (!clientQueryClient)
        clientQueryClient = new QueryClient(config);
    return clientQueryClient;
}
function isBrowser() {
    // Using `typeof window !== 'undefined'` alone is not enough because some users use https://www.npmjs.com/package/ssr-window
    return typeof window !== 'undefined' && typeof window.scrollY === 'number';
    // Alternatively, test whether environment is a *real* browser: https://github.com/brillout/picocolors/blob/d59a33a0fd52a8a33e4158884069192a89ce0113/picocolors.js#L87-L89
}
